import { imageUrl } from '@helpers/image';
import { withBaseProps } from '@hoc/withBaseProps';
import { formatDate, formatDateISO } from '@helpers/date';
import * as React from 'react';
import S from './MediaArticleBanner.styles';
import ShareButtons from '@stories/Components/Misc/ShareButtons/ShareButtons';
const MediaArticleBanner = props => {
    return (React.createElement(S.Container, { id: props.id },
        React.createElement(S.BackgroundImage, null,
            props.image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: props.image.altText, loading: 'eager', role: props.image.altText ? undefined : 'presentation', sizes: '100vw', src: imageUrl(props.image, { width: 480, heightratio: 588 / 1024 }), srcSet: [
                        `${imageUrl(props.image, { width: 320, heightratio: 588 / 1024 })} 320w`,
                        `${imageUrl(props.image, { width: 480, heightratio: 588 / 1024 })} 480w`,
                        `${imageUrl(props.image, { width: 767, heightratio: 588 / 1024 })} 767w`,
                        `${imageUrl(props.image, { width: 1024, heightratio: 460 / 1024 })} 1024w`,
                        `${imageUrl(props.image, { width: 1440, heightratio: 460 / 1440 })} 1440w`,
                        `${imageUrl(props.image, { width: 1920, heightratio: 460 / 1920 })} 1920w`,
                    ].join(','), width: '1440', height: '460' }))),
            React.createElement(S.Overlay, null)),
        React.createElement(S.Inner, null,
            React.createElement(S.ContentColumn, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.DateContainer, null,
                    props.date && (React.createElement(React.Fragment, null,
                        React.createElement("strong", null, "Posted on: "),
                        React.createElement(S.Date, { dateTime: formatDateISO(props.date) },
                            formatDate(props.date),
                            " - "))),
                    props.readTime),
                props.updatedDate && (React.createElement(S.UpdatedDateContainer, null,
                    React.createElement(React.Fragment, null,
                        React.createElement("strong", null, "Last updated: "),
                        React.createElement(S.Date, { dateTime: formatDateISO(props.updatedDate) }, formatDate(props.updatedDate))))),
                props.authorName && (React.createElement(S.AuthorArea, null,
                    React.createElement(S.AuthorImage, null, props.authorImg ? (React.createElement(S.PersonImage, { alt: props.authorImg.altText, loading: 'lazy', role: props.authorImg.altText ? undefined : 'presentation', src: imageUrl(props.authorImg, { width: 64, height: 64 }), width: '64', height: '64' })) : (React.createElement(S.NoImage, null, props.authorName?.charAt(0)))),
                    React.createElement(S.AuthorDetails, null,
                        React.createElement(S.AuthorName, { href: props.authorPage }, props.authorName),
                        props.authorJobTitle && React.createElement(S.AuthorJobTitle, null, props.authorJobTitle)))),
                React.createElement(ShareButtons, { title: props.shareButtonTitle, url: props.shareButtonUrl, options: props.shareOptions })))));
};
export default withBaseProps(MediaArticleBanner);
